import React from 'react';
import { Button as MaterialButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

function Button(props) {
  const { classes } = props;
  return (
    <MaterialButton
      onClick={props.onClick}
      style={props.style}
      key={props.key}
      color={props.color}
      classes={classes}
      className={props.className}
      variant={props.variant}
      disabled={props.disabled}
      primary={props.color}
    >
      {props.icon}
      <span style={props.labelStyle}>{props.label}</span>
      {props.children}
    </MaterialButton>
  );
}

Button.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  labelStyle: PropTypes.object,
  key: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  icon: PropTypes.object,
};

Button.defaultProps = {
  onClick: () => {},
  labelStyle: {},
  label: '',
  children: null,
  style: {},
  key: '',
  color: 'default',
  className: '',
  variant: 'text',
  disabled: false,
  classes: null,
  icon: null,
};

const styles = () => ({
  root: {
    borderRadius: 0,
  },
  label: {
    fontSize: 14,
  },
});

export default withStyles(styles)(Button);



// import React, { Component } from 'react';
// import PropTypes from 'prop-types';

// class Button extends Component {
//   render() {
//     const props = { ...this.props };
//     delete props.variant="contained";

//     if (this.props.variant="contained") {
//       return <RaisedButton {...props} />;
//     }

//     return <FlatButton {...props} />;
//   }
// }

// Button.propTypes = {
//   variant="contained": PropTypes.bool,
// };

// Button.defaultProps = {
//   variant="contained": false,
// };

// export default Button;



// WEBPACK FOOTER //
// ./src/app/components/button/button.js